export const getTotalSupply =
// REPLACE THIS WITH YOUR CONTRACT NAME + ADDRESS
`
import BottomShot from 0x7b6adb682517f137;

pub fun main(): UInt64 {

    return BottomShot.totalSupply;

}
`